/**
 *  Copyright AlpineReplay Inc, 2022. All rights reserved.
 *  Authors: Tabitha Bleil
 */

import React, { useState, useRef } from "react"
import {
    Label,
    TitleSection,
    ModalTitle,
    ContentSection,
    FooterSection,
    Column,
    Button,
    Row,
    Icon,
    Input,
    Color,
    isSmallMobileScreen,
} from "trux"
import { validatePhone, validateEmail } from "../../../util/helpers"

export const DetailsForm = (props) => {
    const [name, setName] = useState("")
    const [email, setEmail] = useState("")
    const [number, setNumber] = useState("")
    const [errors, setErrors] = useState({
        name: null,
        email: null,
        phone: null,
        ready: true,
    })

    const [showCinnamonToast, setShowCinnamonToast] = useState(false)
    const cinnamonToastTimeout = useRef(null)

    const validate = () => {
        var nameError = null
        var emailError = null
        var phoneError = null
        var ready = true

        if (name.length === 0) {
            nameError = "A family member must have a name"
        }

        if (email.length === 0) {
            emailError = "A family member must have an email"
        } else if (!validateEmail(email)) {
            emailError = "Invalid email"
        }

        if (number.length != 0 && !validatePhone(number)) {
            phoneError = "Invalid phone number"
        }

        if (nameError || emailError || phoneError) {
            ready = false
        }

        setErrors({
            name: nameError,
            email: emailError,
            phone: phoneError,
            ready: ready,
        })

        return ready
    }

    const onContinue = () => {
        if (validate()) {
            setShowCinnamonToast(true)
            cinnamonToastTimeout.current = setTimeout(() => {
                console.log("GamePage toast timeout")
                setShowCinnamonToast(false)
            }, 1000)
            //props.onDone()
        }
    }
    return (
        <Column center span="12" className="form">
            <Input
                type={Input.Type.Name}
                label={
                    <Row>
                        <Label
                            type={Label.Type.SmallBody}
                            content="Full name"
                            marginRight="1"
                        />{" "}
                        <Label
                            type={Label.Type.SmallBody}
                            content="*"
                            color={Color.Error}
                        />
                    </Row>
                }
                value={name}
                onChange={(e) => setName(e)}
                error={errors.name}
            />
            <Input
                type={Input.Type.Email}
                label={
                    <Row>
                        <Label
                            type={Label.Type.SmallBody}
                            content="Email"
                            marginRight="1"
                        />{" "}
                        <Label
                            type={Label.Type.SmallBody}
                            content="*"
                            color={Color.Error}
                        />
                    </Row>
                }
                value={email}
                onChange={(e) => setEmail(e)}
                error={errors.email}
            />
            <Input
                type={Input.Type.Text}
                label={<Label type={Label.Type.SmallBody} content="Phone" />}
                value={number}
                onChange={(e) => setNumber(e)}
                error={errors.phone}
                marginBottom="7"
            />
        </Column>
    )
}
